import { useMutation } from 'react-query';
import { ILoginResponse } from './cdaLogin.models';
import {
  INextError,
  LoggerInstance,
  cerebroClient,
  getToken,
  getHeadersCerebro,
} from '@vfit/shared/data-access';
import { datadogRum } from '@datadog/browser-rum';

const cdaLoginService = (
  code?: string,
  endpoint = 'onboarding/login',
  deviceId?: string,
  deviceUserAgent?: string,
  redirectUri?: string
) => {
  const headers = {
    ...getHeadersCerebro(),
    ...(code && { 'x-code': code }),
    ...(deviceId && { 'x-device-id': deviceId }),
    ...(deviceUserAgent && { 'x-device-useragent': deviceUserAgent }),
  };
  datadogRum.addAction('HTTP Request', {
    type: 'CONSUMER',
    method: 'POST',
    url: endpoint,
    body: {},
    token: getToken('uxt'),
    headers,
  });
  return cerebroClient.post(
    endpoint,
    {
      ...(redirectUri && { redirectUri }),
    },
    {
      headers,
    }
  ) as Promise<ILoginResponse>;
};

export const useCDALogin = () => {
  return useMutation(
    ['useCdaLogin'],
    ({
      code,
      endpoint,
      deviceId,
      deviceUserAgent,
      redirectUri,
    }: {
      code?: string;
      endpoint?: string;
      deviceId?: string;
      deviceUserAgent?: string;
      redirectUri?: string;
    }) => cdaLoginService(code, endpoint, deviceId, deviceUserAgent, redirectUri),
    {
      onSuccess: (data: ILoginResponse) => {
        LoggerInstance.info(`SUCCESS useCdaLogin: `, data);
        datadogRum.addAction('HTTP Response', {
          type: 'CONSUMER',
          url: 'onboarding/login',
          token: getToken('uxt'),
          status: '200',
          response: data,
        });
      },
      onError: (error: INextError) => {
        LoggerInstance.error(`ERROR on useCdaLogin: `, error);
      },
    }
  );
};
